import { RosterItem, StatItem, NavLink } from './types';

export const ROSTER_DATA: RosterItem[] = [
  {
    id: '1',
    deploymentId: '01',
    name: 'STRATEGIC EXPOSURE',
    supporting: "Perform in front of engaged audiences across major cities, helping you grow your fanbase beyond your local market.",
    status: 'active',
  },
  {
    id: '2',
    deploymentId: '02',
    name: 'PROFESSIONAL PRODUCTION',
    supporting: "Our team ensures high-quality stage, sound, and visual coordination to give you a polished live experience.",
    status: 'active',
  },
  {
    id: '3',
    deploymentId: '03',
    name: 'REAL INDUSTRY ACCESS',
    supporting: "Connect with promoters, creatives, and industry professionals at every stop of the tour.",
    status: 'active',
  },
  {
    id: '4',
    deploymentId: '04',
    name: 'BRAND DEVELOPMENT',
    supporting: "We support artists not just on stage, but in positioning, presentation, and long-term growth.",
    status: 'active',
  },
  {
    id: '5',
    deploymentId: '05',
    name: 'MULTI-CITY REACH',
    supporting: "Expand your visibility across key regions with structured tour routing and targeted promotion.",
    status: 'active',
  },
  {
    id: '6',
    deploymentId: '06',
    name: 'DEDICATED TOUR SUPPORT',
    supporting: "From logistics to coordination, our team works behind the scenes so you can focus on performing.",
    status: 'active',
  },
];

export const STATS_DATA: StatItem[] = [
  { label: 'GLOBAL CIRCUITS', value: '50+ ARENA STAGES' },
  { label: 'The Exposure', value: '150k + LIVE AUDIENCE' },
  { label: 'Power', value: 'ALL ACCESS CLEARANCE' },
];

export const FOOTER_LINKS: NavLink[] = [
  { label: 'Network', href: '#' },
  { label: 'Support', href: '#' },
  { label: 'Legal', href: '#' },
];

export const ONGOING_TOURS = [
  {
    id: 't-02',
    image: 'https://i.imgur.com/n9MpWgY.jpg',
  },
  {
    id: 't-06',
    image: 'https://i.imgur.com/TqiWu5U.jpg',
  }
];

export const UPCOMING_TOURS = [
  {
    id: 'u-08',
    image: 'https://i.imgur.com/qnrqdcz.png',
    title: 'Rod Wave Tour',
    dates: [
      { date: 'September 12, 2026', state: 'PA', location: 'Philadelphia • Xfinity Mobile Arena' },
      { date: 'September 14, 2026', state: 'PA', location: 'Philadelphia • Xfinity Mobile Arena' },
      { date: 'September 15, 2026', state: 'NC', location: 'Raleigh • Lenovo Center' },
      { date: 'September 17, 2026', state: 'AL', location: 'Birmingham • Legacy Arena at the BJCC' },
      { date: 'September 19, 2026', state: 'LA', location: 'New Orleans • Smoothie King Center' },
      { date: 'September 21, 2026', state: 'TX', location: 'Houston • Toyota Center' },
      { date: 'September 22, 2026', state: 'TX', location: 'Houston • Toyota Center' },
      { date: 'September 23, 2026', state: 'TX', location: 'Austin • Moody Center' },
      { date: 'September 26, 2026', state: 'TX', location: 'Dallas • American Airlines Center' },
      { date: 'September 27, 2026', state: 'TX', location: 'Dallas • American Airlines Center' },
      { date: 'October 1, 2026', state: 'CA', location: 'Inglewood • Intuit Dome' },
      { date: 'October 4, 2026', state: 'AZ', location: 'Phoenix • Mortgage Matchup Center' },
      { date: 'October 7, 2026', state: 'CA', location: 'San Francisco • Chase Center' },
      { date: 'October 8, 2026', state: 'CA', location: 'Sacramento • Golden 1 Center' },
      { date: 'October 12, 2026', state: 'MO', location: 'St. Louis • Enterprise Center' },
      { date: 'October 14, 2026', state: 'TN', location: 'Nashville • Bridgestone Arena' },
      { date: 'October 16, 2026', state: 'DC', location: 'Washington • Capital One Arena' },
      { date: 'October 19, 2026', state: 'MI', location: 'Detroit • Little Caesars Arena' },
      { date: 'October 22, 2026', state: 'OH', location: 'Columbus • Schottenstein Center' },
      { date: 'October 23, 2026', state: 'PA', location: 'Pittsburgh • PPG Paints Arena' },
      { date: 'October 25, 2026', state: 'MA', location: 'Boston • TD Garden' },
      { date: 'October 27, 2026', state: 'NY', location: 'Brooklyn • Barclays Center' },
      { date: 'October 28, 2026', state: 'NY', location: 'Brooklyn • Barclays Center' },
      { date: 'October 31, 2026', state: 'IL', location: 'Chicago • United Center' },
      { date: 'November 1, 2026', state: 'IL', location: 'Chicago • United Center' },
      { date: 'November 3, 2026', state: 'NC', location: 'Charlotte • Spectrum Center' },
      { date: 'November 6, 2026', state: 'SC', location: 'Columbia • Colonial Life Arena' },
      { date: 'November 9, 2026', state: 'FL', location: 'Orlando • Kia Center' },
      { date: 'November 10, 2026', state: 'FL', location: 'Orlando • Kia Center' },
      { date: 'November 14, 2026', state: 'FL', location: 'Sunrise • Amerant Bank Arena' },
      { date: 'November 15, 2026', state: 'FL', location: 'Sunrise • Amerant Bank Arena' },
      { date: 'November 18, 2026', state: 'GA', location: 'Atlanta • State Farm Arena' },
      { date: 'November 19, 2026', state: 'GA', location: 'Atlanta • State Farm Arena' }
    ]
  }
];

export const COMPLETED_TOURS = [
  {
    id: 'u-01',
    image: 'https://i.imgur.com/gxUe6VR.jpg',
  },
  {
    id: 'u-02',
    image: 'https://i.imgur.com/rXuq9s3.jpg',
  },
  {
    id: 'u-03',
    image: 'https://i.imgur.com/eH9S2ia.jpg',
  },
  {
    id: 'u-05',
    image: 'https://i.imgur.com/aTgN4QF.jpg',
  },
  {
    id: 'u-06',
    image: 'https://i.imgur.com/0lSV60T.jpg',
  },
  {
    id: 'u-07',
    image: 'https://i.imgur.com/ZLUeR9e.png',
  },
  {
    id: 't-01',
    image: 'https://i.imgur.com/V4nZCvZ.jpg',
  },
  {
    id: 't-03',
    image: 'https://i.imgur.com/9j4lav1.jpg',
  },
  {
    id: 't-04',
    image: 'https://i.imgur.com/du8KTBL.jpg',
  },
  {
    id: 't-05',
    image: 'https://i.imgur.com/Fp8G8lv.jpg',
  }
];

export const TEAM_MEMBERS = [
  {
    name: "Victor Dixon",
    role: "Tour Manager",
    image: "https://i.imgur.com/kPoTQfY.jpeg",
    desc: "Oversees logistics, scheduling, and on-the-road operations to keep every stop running smoothly."
  },
  {
    name: "C. Brooks",
    role: "Director of Marketing & Brand Partnerships",
    image: "https://i.imgur.com/1s276Xo.png",
    desc: "Leads global brand strategy and secures high-value partnerships to amplify tour reach and revenue."
  },
  {
    name: "Tahira",
    role: "Marketing & Artist Relations",
    image: "https://i.imgur.com/lLvlkOK.jpeg",
    desc: "Handles promotion, communications, and artist coordination across the tour."
  },
  {
    name: "Rowan",
    role: "Creative & Production Lead",
    image: "https://i.imgur.com/dw94i4b.jpeg",
    desc: "Handles stage design, visuals, and overall show experience from setup to final cue."
  }
];

export const GALLERY_IMAGES = [
  {
    id: 1,
    url: "https://i.imgur.com/590xPCo.png",
    title: "Crimson Surge",
    location: "Tokyo Dome, Japan",
    date: "2024.11.05",
    iso: "ISO 3200",
    shutter: "1/500",
    desc: "Crowd synchronization at peak energy levels."
  },
  {
    id: 2,
    url: "https://i.imgur.com/f1QH65G.png",
    title: "Azure Void",
    location: "O2 Arena, London",
    date: "2024.10.22",
    iso: "ISO 1600",
    shutter: "1/250",
    desc: "Pre-show lighting calibration sequence."
  },
  {
    id: 3,
    url: "https://i.imgur.com/zfSXLRJ.png",
    title: "Vocal Point",
    location: "Madison Square Garden, NY",
    date: "2024.09.15",
    iso: "ISO 800",
    shutter: "1/400",
    desc: "Lead vocalist isolation during bridge."
  },
  {
    id: 4,
    url: "https://i.imgur.com/TCwqmLZ.png",
    title: "Collective High",
    location: "Accor Arena, Paris",
    date: "2025.01.10",
    iso: "ISO 6400",
    shutter: "1/60",
    desc: "Audience interaction protocol engaged."
  },
  {
    id: 5,
    url: "https://i.imgur.com/qhRpLJd.png",
    title: "Riff Frequency",
    location: "Mercedes-Benz Arena, Berlin",
    date: "2025.02.01",
    iso: "ISO 400",
    shutter: "1/1000",
    desc: "Bass frequency resonance check."
  },
  {
    id: 6,
    url: "https://i.imgur.com/3jYM8Oe.png",
    title: "Core Rhythm",
    location: "Wembley Stadium, London",
    date: "2024.12.12",
    iso: "ISO 1200",
    shutter: "1/320",
    desc: "Percussion unit in full motion."
  }
];

export const FAQ_DATA = [
  {
    question: "What does StarRoad Touring do?",
    answer: "StarRoad Touring is a music tour placement company focused on connecting rising artists with major touring opportunities. We work to position emerging talent as opening acts on high-profile tours, giving artists the chance to perform in front of large audiences and gain real industry exposure."
  },
  {
    question: "Who can apply?",
    answer: "We invite solo artists, bands, and performers from any genre to submit their music for consideration. We’re looking for artists who are serious about their craft, prepared for large-scale performances, and committed to growing their careers."
  },
  {
    question: "What happens after I apply?",
    answer: "Every submission is reviewed by our team to evaluate overall potential, stage readiness, and tour compatibility. If an artist is considered a strong match for a current or upcoming opportunity, our team will reach out directly with further details. Please note that due to the number of submissions we receive, we are only able to contact artists who move forward in the process."
  },
  {
    question: "How are touring opportunities decided?",
    answer: "Tour placements are based on several factors, including musical style, audience alignment, performance experience, branding, and professionalism. We aim to create opportunities that make sense strategically for both the emerging artist and the headlining act."
  },
  {
    question: "Do you work with specific genres?",
    answer: "No. StarRoad Touring considers artists across all genres. Opportunities vary depending on current tour availability and industry partnerships."
  },
  {
    question: "How can I get in touch with StarRoad Touring?",
    answer: "For general inquiries, please email us at staroadtouring@gmail.com. You may also reach out through the social media channels listed in the footer of our website."
  }
];